import './App.css';
import { PageBlock } from './components/PageBlock';
import video1 from './assets/videoExample1.mp4';
import video2 from './assets/videoExample2.mp4';
import video3 from './assets/videoExample3.mp4';
import video4 from './assets/videoExample4.mp4';
import { PageHeader } from './components/PageHeader';
import { HighlightsBlock } from './components/HighlightsBlock';
import { TeamBlock } from './components/TeamBlock';
import { PageFooter } from './components/PageFooter';

export const App = () => {
  return (
    <div className="App">
      <PageHeader />
      <PageBlock
        title="Fedrigoni Exclusive Papers"
        video={video1}
        text="Our self-adhesive papers use facestock developed by Fedrigoni Special Papers, a name synonymous with tradition and excellence. Designed to preserve their integrity even after lamination, they deliver a flawless finish and added value at every stage."
        afterImageText="Imagine a journey through time, where each grain of sand becomes a fleeting moment in an hourglass. The essence of paper emerges in its purest form. Soft cotton, pure white, and warm sand tones are woven into its fibers (Cotton Bianca Sabbia), offering elegance in every detail. The design, sober and refined, honors the authenticity of the paper, inviting you to savor its timeless beauty—a celebration of simplicity and excellence, like the finest wines."
        afterImageTitle="COTONE BIANCO SABBIA ULTRA WS"
        href="https://myselfadhesives.fedrigoni.com/en_en/catpc0043"
        background='white'
      />
      <PageBlock
        title="Fedrigoni Premium Papers"
        video={video2}
        text="Crafted in the renowned Fedrigoni Group paper mills, our premium facestock transforms self-adhesive materials into products of unmatched quality. From lamination to the finished label, every step is designed to deliver excellence you can see and feel."
        afterImageText="This label draws inspiration from old printed maps that, in today's digital age, become portals to mythical eras. Gold stamping, paper overlay, embossing and debossing infuse this label with vitality, evoking the charm of antique paper. Digital printed on our Luminous White Felt X-Dry."
        afterImageTitle="LUMINOUS WHITE FELT X-DRY"
        href="https://myselfadhesives.fedrigoni.com/en_en/wne1209"
        background='#25242D'
      />
      <PageBlock
        title="Essentials"
        video={video3}
        text="Discover a versatile range of premium papers and films designed for self-adhesive applications. Our facestock delivers consistent quality from start to finish, ensuring flawless transformation into unique products that stand out."
        afterImageText="The iconic Tintoretto adhesive paper, is now transformed into a 100% circular solution. Proudly made in Italy, this material retains its distinctive texture and high performance while offering added versatility. Crafted with a unique mix of recycled and pure ECF fibers, Re-Play Tintoretto Gesso ensures durability and impeccable print results, making it perfect for your most refined projects."
        afterImageTitle="RE-PLAY TINTORETTO GESSO"
        href="https://selfadhesives.fedrigoni.com/news/tintoretto-gesso-a-classic-paper-now-available-in-the-re-play-family/"
        background='white'
      />
      <PageBlock
        title="Neck Labels"
        video={video4}
        text="Exclusively developed by Fedrigoni Special Papers for Fedrigoni Self-Adhesives, this premium facestock range is crafted for high-end neck labels that elevate and complement main labels. Made from top-quality pulp, these materials guarantee elegance and performance—perfect for wine and luxury products."
        afterImageText="Wine label realized with a coordinated habillage capable to remind of the elegance and refinement of this iconic movement. Both the main and neck label of the champagne brut are printed on our Tintoretto Gesso. An uncoated and felt-marked paper made with FSC® certified and environment-friendly ECF pulp.To shape your creative project, get inspired by the vibes of the first cinematographic movement testifying the immediacy of becoming."
        afterImageTitle="TINTORETTO GESSO NECK LABEL"
        href="https://myselfadhesives.fedrigoni.com/en_en/catpc0003"
        background='#25242D'
      />
      <HighlightsBlock />
      <TeamBlock />
      <PageFooter />
    </div>
  );
}
